export const contact = {
label: 'Contacto',
title: 'Oficina Corporativa',
subtitle: 'Conéctese con nuestro equipo para consultas empresariales, oportunidades de asociación e información corporativa.',
address_title: 'Dirección de la Oficina',
address: 'ONE MORE GLOBAL INC.\n8556 KATY FREEWAY, SUITE 120\nHOUSTON, TX 77024',
form_title: 'Enviar una Consulta',
name: 'Nombre Completo',
name_placeholder: 'Ingrese su nombre completo',
email: 'Dirección de Correo Electrónico',
email_placeholder: 'Ingrese su dirección de correo electrónico',
company: 'Empresa / Organización',
company_placeholder: 'Ingrese el nombre de su empresa',
country: 'País / Región',
country_placeholder: 'Ingrese su país o región',
category: 'Categoría de Consulta',
category_placeholder: 'Seleccione una categoría',
categories: {
  business_development: 'Desarrollo Empresarial',
  distribution: 'Asociaciones de Distribución',
  partnership: 'Asociaciones Estratégicas',
  compliance: 'Cumplimiento y Regulatorio',
  media: 'Medios y Prensa',
  careers: 'Carreras',
  general: 'Consulta General',
},
message: 'Mensaje',
message_placeholder: 'Describa su consulta...',
consent: 'Consiento el procesamiento de mis datos personales de acuerdo con la Política de Privacidad.',
submit: 'Enviar Consulta',
submitting: 'Enviando...',
success: 'Gracias por su consulta. Nos pondremos en contacto con usted en breve.',
error: 'No se pudo enviar su consulta. Por favor, inténtelo de nuevo más tarde.',
};
